import React from 'react';

import { BodyText } from '../../Text';

// ────────────────────────────────────────────────────────────────────────────────

export const LineItemDescription: React.FC<LineItemDescriptionProps> = (
  props,
) => {
  const { children, productSlug, selectable } = props;

  return (
    <BodyText
      selectable={selectable}
      size={4}
      testID={`sg-line-item-card-description-${productSlug}`}
    >
      {children}
    </BodyText>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

type LineItemDescriptionProps = {
  readonly productSlug: string;
  readonly selectable?: boolean;
};
